var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "subscription-page" }, [
    _vm.subscriptionsComputed.length
      ? _c("div", { staticClass: "subscription-actions" }, [
          _c(
            "button",
            {
              staticClass: "manage-subscriptions",
              attrs: { type: "button" },
              on: { click: _vm.manageSubscriptions }
            },
            [
              _c("portal-icon", { attrs: { name: "settings", size: 17 } }),
              _vm._v(" " + _vm._s(_vm.$t("subscriptions.manage")) + " ")
            ],
            1
          )
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "subscription-table-shell portal-compact-list-shell" },
      [
        _c("v-data-table", {
          staticClass: "portal-compact-table subscription-table",
          attrs: {
            "item-key": "id",
            headers: _vm.headers,
            items: _vm.subscriptionsComputed,
            "hide-default-footer": true,
            "items-per-page": -1,
            "mobile-breakpoint": 0
          },
          on: {
            "click:row": function($event) {
              return _vm.handleItemClick($event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "item.periodStart",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "div",
                    { staticClass: "subscription-period" },
                    [
                      _c("portal-icon", {
                        attrs: { name: "calendar-days", size: 16 }
                      }),
                      item.periodStart && item.periodEnd
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    item.periodStart
                                  ).toLocaleString()
                                ) +
                                " - " +
                                _vm._s(
                                  _vm.DateTime.fromISO(
                                    item.periodEnd
                                  ).toLocaleString()
                                ) +
                                " "
                            )
                          ])
                        : _c("span", [_vm._v("--")])
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "item.daysUntilDue",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c("span", { staticClass: "portal-cell-muted" }, [
                    _vm._v(_vm._s(item.daysUntilDue || "--"))
                  ])
                ]
              }
            },
            {
              key: "item.subscriptionItems",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "div",
                    { staticClass: "subscription-items" },
                    _vm._l(item.subscriptionItems, function(subItem, index) {
                      return _c("div", { key: item.id + ":" + index }, [
                        _vm._v(
                          " " +
                            _vm._s(subItem.quantity) +
                            " x " +
                            _vm._s(subItem.description) +
                            " @ " +
                            _vm._s(
                              _vm.$formatters.dollars(
                                subItem.amount,
                                true,
                                true,
                                subItem.currency
                              )
                            ) +
                            " "
                        )
                      ])
                    }),
                    0
                  )
                ]
              }
            },
            {
              key: "item.status",
              fn: function(ref) {
                var item = ref.item
                return [
                  _c(
                    "portal-status-pill",
                    {
                      attrs: {
                        background: _vm.statusDetail(item).background,
                        color: _vm.statusDetail(item).color
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.statusDetail(item).label) + " ")]
                  )
                ]
              }
            },
            {
              key: "item.action",
              fn: function() {
                return [
                  _c("portal-icon", {
                    staticClass: "row-chevron",
                    attrs: { name: "chevron-right", size: 17 }
                  })
                ]
              },
              proxy: true
            }
          ])
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }